import {
  GET_SETUP_INFO,
  EDIT_SETUP_INFO,
  ADD_VC,
  DELETE_VC,
} from "../actions/types";

const INITIAL_STATE = {
  setupTimes: null,
  error: false,
  errorDescription: null,
  path: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SETUP_INFO:
      return {
        ...state,
        setupTimes: action.payload.data,
        error: action.payload.error,
        errorDescription: action.payload.errorDescription,
        path: "/admin",
      };
    case EDIT_SETUP_INFO:
      return {
        ...state,
        setupTimes: action.payload.updatedData.rows,
        error: action.payload.error,
        errorDescription: action.payload.errorDescription,
        path: "/admin/edit",
      };
    case ADD_VC:
      return {
        ...state,
        setupTimes: action.payload.updatedData.rows,
        error: action.payload.updatedData.error,
        errorDescription: action.payload.updatedData.errorDescription,
        path: "/admin/add",
      };
    case DELETE_VC:
      return {
        ...state,
        setupTimes: action.payload.updatedData.rows,
        error: action.payload.updatedData.error,
        errorDescription: action.payload.updatedData.errorDescription,
        path: "/admin/delete",
      };
    default:
      return state;
  }
};
